const isCompanyOwnedDealerZip = async postCode => {
  try {
    const response = await fetch(
      `${process.env.GATSBY_POSTCODE_SEARCH_API}?postalCode=${postCode}`
    );

    const dealers = await response.json();
    const result = dealers?.some(dealer => dealer?.isCompanyOwned);

    return result;
  } catch (error) {
    console.error(error);
  }
  return false;
};

export default isCompanyOwnedDealerZip;
